export default [
  // {
  //   path: 'overview',
  //   name: 'Overview',
  //   redirect : 'readme',
  //   component: () => import(/* webpackChunkName: "my-app-overview" */ '../views/Overview.vue'),
  // },
  // {
  //   path: 'readme',
  //   name: 'Readme',
  //   component: () => import(/* webpackChunkName: "my-app-overview" */ '../views/Readme.vue'),
  // },

  {
    path: '/region',
    name: 'Home',
    component: () => import(/* webpackChunkName: "my-app-overview" */ '../views/Region.vue'),
    meta: {
      mainNavEnabled: false,  // Main nav should be enabled on the region selection page
      topBarEnabled: false, // top bar nav should be enabled on the region selection page
    }
  },
 
  {
    path: 'category',
    name: 'Category',
    component: () => import(/* webpackChunkName: "my-app-overview" */ '../views/Category.vue'),
  },
  {
    path: 'category/commodity',
    name: 'Commodity',
    component: () => import(/* webpackChunkName: "my-app-overview" */ '../views/Commodity.vue'),
  },
  {
    path: 'category/commodity/segment/:decodeUrl?',
    name: 'Segment',
    component: () => import(/* webpackChunkName: "my-app-overview" */ '../views/Segment.vue'),
  },
  {
    path: '/segment/:decodeUrl?',
    name: 'SegmentView',
    component: () => import(/* webpackChunkName: "my-app-overview" */ '../views/Segment.vue'),
  },
  {
    path: 'segmentform',
    name: 'SegmentForm',
    component: () => import(/* webpackChunkName: "my-app-overview" */ '../views/SegmentForm.vue'),
  },
  {
    path: 'category/commodity/segmentform',
    name: 'SegmentFormView',
    component: () => import(/* webpackChunkName: "my-app-overview" */ '../views/SegmentForm.vue'),
  },
  {
    path: 'segmentformcm',
    name: 'SegmentFormCM',
    component: () => import(/* webpackChunkName: "my-app-overview" */ '../views/SegmentFormCM.vue'),
  },
  {
    path: 'buying-group',
    name: 'Buying Group',
    component: () => import(/* webpackChunkName: "my-app-overview" */ '../views/BuyingGroup.vue'),
  },
  {
    path: 'regionandplants',
    name: 'RegionAndPlants',
    component: () => import(/* webpackChunkName: "my-app-overview" */ '../views/RegionAndPlants.vue'),
  },
  {
    path: 'updatestostrategy',
    name: 'UpdatesToStrategy',
    component: () => import(/* webpackChunkName: "my-app-overview" */ '../views/UpdatesToStrategy.vue'),
  },
 
  {
    path: 'welcome',
    name: 'Welcome',
    component: () => import(/* webpackChunkName: "my-app-overview" */ '../views/Welcome.vue'),
  },
  //  {
  //   path: 'faq',
  //   name: 'FAQ',
  //   component: () => import(/* webpackChunkName: "my-app-overview" */ '../views/FAQ.vue'),
  // },
  {
    path: 'categorysubmission',
    name: 'CategorySubmission',
    component: () => import(/* webpackChunkName: "my-app-overview" */ '../views/CategorySubmission.vue'),
  },
  {
    path: 'commoditysubmission',
    name: 'CommoditySubmission',
    component: () => import(/* webpackChunkName: "my-app-overview" */ '../views/CommoditySubmission.vue'),
  },
   {
    path: 'segmentsubmission',
    name: 'SegmentSubmission',
    component: () => import(/* webpackChunkName: "my-app-overview" */ '../views/SegmentSubmission.vue'),
  },
  {
    path: 'categoryrequests',
    name: 'CategoryRequests',
    component: () => import(/* webpackChunkName: "my-app-overview" */ '../views/CategoryRequests.vue'),
  },
  {
    path: 'commodityrequests',
    name: 'CommodityRequests',
    component: () => import(/* webpackChunkName: "my-app-overview" */ '../views/CommodityRequests.vue'),
  },
   {
    path: 'segmentrequests',
    name: 'SegmentRequests',
    component: () => import(/* webpackChunkName: "my-app-overview" */ '../views/SegmentRequests.vue'),
  },
  {
    path: 'quicklinks',
    name: 'QuickLinks',
    component: () => import(/* webpackChunkName: "my-app-overview" */ '../views/QuickLinks.vue'),
  },
  {
    path: 'categorylog',
    name: 'Category Log',
    component: () => import(/* webpackChunkName: "my-app-overview" */ '../views/CategoryLog.vue'),
  },
  {
    path: 'commoditylog',
    name: 'Commodity Log',
    component: () => import(/* webpackChunkName: "my-app-overview" */ '../views/CommodityLog.vue'),
  },
  {
    path: 'segmentlog',
    name: 'Segment Log',
    component: () => import(/* webpackChunkName: "my-app-overview" */ '../views/SegmentLog.vue'),
  },
]
